<template>
    <header>
        <div class="container-fluid m-0">
            <div class="row no-gutters " style="background-color: rgb(249 249 249)">
                <div class="col-4 d-flex justify-content-start align-items-center">
                    <!-- Icon cờ Việt Nam, đặt ở mép trái màn hình -->
                    <img :src='iconChiTiet.logoQuocKi' alt="Quốc kỳ Việt Nam" class="m-0" style="height: 24px;">
                </div>
                <div class="col-4 d-flex justify-content-center align-items-center">
                    <!-- Tên cửa hàng, căn giữa -->
                    <h5 style="font-family: system-ui;" class="m-0">Tên Cửa Hàng</h5>
                </div>
                <div class="col-4 d-flex justify-content-end align-items-center">
                    <!-- Các icon alarm và home, đặt ở mép phải màn hình -->
                    <i class="fa fa-bell-o fa-2x m-2" aria-hidden="true"></i>
                    <i class="fa fa-home fa-2x m-0" aria-hidden="true"></i>
                </div>
            </div>
        </div>
    </header>

    <div class="container-fluid m-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container-fluid">
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <li class="nav-item" v-for="category in categories" :key="category.id">
                            <a class="nav-link" href="#" @click="selectCategory(category)">
                                {{ category.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>

</template>
<script>
import { imageUrlsChiTietCuaHang } from "@/components/js/urlImgChiTietCuaHang";

export default {
    data() {
        return {
            iconChiTiet: imageUrlsChiTietCuaHang,
        }
    },
    mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      // Gọi dịch vụ API để lấy danh sách các danh mục
      // Giả sử bạn gọi một API và nhận về kết quả dưới dạng JSON
      this.goiDichVuLayCategories();
    },
    selectCategory(category) {
      // Xử lý khi người dùng chọn một danh mục
      console.log('Category selected:', category.name);
      // Có thể bạn muốn lưu trữ danh mục được chọn hoặc thực hiện một hành động nào đó
    },
  
  }
}
</script>